/**
 * Mobile drawer submenu accordion — use when empire.js cannot be edited.
 * - Removes theme click.mobile-nav on [data-mobile-nav-panel] (Empire re-binds each time the drawer opens).
 * - Toggles submenus via data-accordion-state + classes (no Accordion API).
 */
(function () {
  if (typeof jQuery === 'undefined') return;

  jQuery(function ($) {
    var $panel = $('[data-mobile-nav-panel]');
    var $navRoot = $('[data-mobile-nav]');
    if (!$panel.length || !$navRoot.length) return;

    var ACTIVE = 'navmenu-link-parent-active';
    var SEL_PARENT_LI = 'li[data-navmenu-parent]';
    var SEL_LINK = '.navmenu-link-parent';
    var SEL_BTN = '.navmenu-button';
    var SEL_SUB = '[data-navmenu-submenu]';

    function ensureAllProductsLink() {
      var $topMenu = $panel.find('ul.navmenu.navmenu-depth-1').first();
      if (!$topMenu.length) return;

      var $realAged = $topMenu.children('li.navmenu-id-realaged').first();
      if (!$realAged.length) return;

      var $existing = $topMenu.children('li.pm-mobile-all-products');
      if ($existing.length) return;

      var $item = $('<li>', {
        class: 'navmenu-item navmenu-id-all-products pm-mobile-all-products'
      });

      $('<a>', {
        class: 'navmenu-link mdc-ripple-surface',
        href: '/collections/all',
        text: 'All Products'
      }).appendTo($item);

      $item.insertBefore($realAged);
    }


    function stripEmpireHandlers() {
      $panel.off('click.mobile-nav');
    }

    function submenuFromLink($link) {
      return $link.siblings(SEL_SUB).first();
    }

    function isExpanded($link, $menu) {
      return (
        $link.hasClass(ACTIVE) ||
        $link.attr('aria-expanded') === 'true' ||
        $menu.attr('data-accordion-state') === 'open'
      );
    }

    function closeNested($container) {
      $container.find('.' + ACTIVE).each(function () {
        closeRow($(this));
      });
    }

    function closeRow($link) {
      var $menu = submenuFromLink($link);
      if (!$menu.length) return;

      closeNested($menu);

      var el = $menu[0];
      el.setAttribute('data-accordion-state', 'closed');
      el.removeAttribute('data-accordion-animation');
      el.style.removeProperty('height');
      el.style.setProperty('--menu-open-height', '0px');

      $link.removeClass(ACTIVE);
      $link.attr('aria-expanded', 'false');
      $link.siblings(SEL_BTN).attr('aria-expanded', 'false');
    }

    function openRow($link) {
      var $menu = submenuFromLink($link);
      if (!$menu.length) return;

      var el = $menu[0];
      $link.addClass(ACTIVE);
      el.removeAttribute('data-accordion-animation');
      el.setAttribute('data-accordion-state', 'open');
      el.style.removeProperty('height');

      requestAnimationFrame(function () {
        el.style.setProperty('--menu-open-height', el.scrollHeight + 'px');
      });

      $link.attr('aria-expanded', 'true');
      $link.siblings(SEL_BTN).attr('aria-expanded', 'true');
    }

    function closeSiblingRows($currentRow) {
      $currentRow.siblings(SEL_PARENT_LI).each(function () {
        var $sibLink = $(this).children(SEL_LINK).first();
        if ($sibLink.length && $sibLink.hasClass(ACTIVE)) {
          closeRow($sibLink);
        }
      });
    }

    function resetAllSubmenus() {
      $panel.find(SEL_SUB).each(function () {
        this.setAttribute('data-accordion-state', 'closed');
        this.removeAttribute('data-accordion-animation');
        this.style.removeProperty('height');
        this.style.setProperty('--menu-open-height', '0px');
      });
      $panel.find('.' + ACTIVE).removeClass(ACTIVE);
      $panel.find(SEL_PARENT_LI + ' > ' + SEL_LINK).attr('aria-expanded', 'false');
      $panel.find(SEL_PARENT_LI + ' > ' + SEL_BTN).attr('aria-expanded', 'false');
    }

    function bindOurHandlers() {
      $panel
        .off('click.pmNavSub', SEL_PARENT_LI + ' > ' + SEL_LINK)
        .on('click.pmNavSub', SEL_PARENT_LI + ' > ' + SEL_LINK, function (e) {
          e.preventDefault();

          var $link = $(this);
          var $menu = submenuFromLink($link);
          if (!$menu.length) return;

          if (isExpanded($link, $menu)) {
            closeRow($link);
            return;
          }

          closeSiblingRows($link.closest(SEL_PARENT_LI));
          openRow($link);
        });

      $panel
        .off('click.pmNavSub', SEL_PARENT_LI + ' > ' + SEL_BTN)
        .on('click.pmNavSub', SEL_PARENT_LI + ' > ' + SEL_BTN, function (e) {
          e.preventDefault();

          var $btn = $(this);
          var $link = $btn.siblings(SEL_LINK).first();
          var $menu = submenuFromLink($link);
          if (!$link.length || !$menu.length) return;

          if (isExpanded($link, $menu)) {
            closeRow($link);
          } else {
            closeSiblingRows($link.closest(SEL_PARENT_LI));
            openRow($link);
          }
        });
    }

    ensureAllProductsLink();
    stripEmpireHandlers();
    bindOurHandlers();

    var mo = new MutationObserver(function () {
      var open = $navRoot.attr('data-open') === 'true';
      if (open) {
        ensureAllProductsLink();
        stripEmpireHandlers();
      } else {
        resetAllSubmenus();
      }
    });
    mo.observe($navRoot[0], { attributes: true, attributeFilter: ['data-open'] });
  });
})();
